<div class="match-game" cdkDropListGroup>
  <div class="match-col">
    <div class="match-col__label">Terms</div>
    <div cdkDropList id="unplaced" [cdkDropListData]="unplaced" [cdkDropListConnectedTo]="connectedListIds"
      (cdkDropListDropped)="drop($event, unplaced)" class="match-dropzone">
      <div class="term-card" *ngFor="let term of unplaced" cdkDrag [cdkDragDisabled]="!!result">{{term.text}}</div>
    </div>
  </div>

  <div class="match-col">
    <div class="match-col__label">Definitions</div>
    <div class="def-slot" *ngFor="let slot of slots"
      [class.def-slot--correct]="slot.state === 'correct'" [class.def-slot--incorrect]="slot.state === 'incorrect'">
      <div cdkDropList [id]="'slot-' + slot.def.id" [cdkDropListData]="slot.placed"
        [cdkDropListConnectedTo]="connectedListIds" (cdkDropListDropped)="drop($event, slot.placed)"
        class="match-dropzone match-dropzone--slot">
        <div class="term-card term-card--placed" *ngFor="let term of slot.placed" cdkDrag [cdkDragDisabled]="!!result">{{term.text}}</div>
        <div class="def-slot__placeholder" *ngIf="slot.placed.length === 0">Drop a term here</div>
      </div>
      <div class="def-slot__text">{{slot.def.text}}</div>
    </div>
  </div>
</div>

<div class="game-actions">
  <button type="button" class="btn btn--sm m-0" [disabled]="!allPlaced || checking" (click)="checkAnswer()" *ngIf="!result">
    Check answer
  </button>
  <button type="button" class="btn btn--sm m-0" (click)="tryAgain()" *ngIf="result">Try again</button>
  <span class="game-feedback" *ngIf="result" [class.game-feedback--good]="result.allCorrect" [class.game-feedback--bad]="!result.allCorrect">
    {{result.allCorrect ? 'All correct' : (result.correctTermIds.length + ' of ' + (result.correctTermIds.length + result.incorrectTermIds.length) + ' correct')}} — attempt recorded.
  </span>
</div>
